import React from 'react';
import { Button, Dialog } from '@betareader/design-system';
import styled from 'styled-components';
import { withTranslation, Trans } from 'react-i18next';
import Icon from '../AppIcon';

const Section = styled.section`
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  gap: 12px;
  margin-bottom: 20px;
`;

const SectionTitle = styled.h3`
  margin: 0 0 8px;
  font-size: 1rem;
`;

const SupportModal = ({
  t, onClose, open, onStartSupportChat, signedIn, mail = 'support@betareader.io'
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    title={t('Support')}
    actions={<Button variant="secondary" onClick={onClose}>{t('Close', 'Close')}</Button>}
  >
    <Section>
      <Icon name="question circle outline" aria-hidden="true" size="large" />
      <div>
        <SectionTitle>{t('HelpArticles')}</SectionTitle>
        <Trans i18nKey="FindHelpArticlesMessage">
          <span style={{ fontSize: '1em' }}>
            Need help? check out our
            <a href="https://betareader.io/help" target="_blank" rel="noopener noreferrer">
            {' '}
            help
            {' '}
            </a>
            section, full of help articles to guide you.
          </span>
        </Trans>
      </div>
    </Section>
    <Section>
      <Icon name="comments outline" aria-hidden="true" size="large" />
      <div>
        <SectionTitle>{t('TalkToSupport')}</SectionTitle>
        {signedIn && (
          <>
            <Button id="support-modal-chat-button" onClick={onStartSupportChat}>
              {t('StartSupportChat')}
            </Button>
            <p>{t('Or')}</p>
          </>
        )}
        <Trans i18nKey="EmailSupportMessage">
          <span>
            Send an email to <a href={`mailto:${mail}`}>{{ mail }}</a>, and we will answer as soon as we can.
          </span>
        </Trans>
      </div>
    </Section>
  </Dialog>
);

export default withTranslation()(SupportModal);
